import { render, staticRenderFns } from "./crumbLayout.vue?vue&type=template&id=2fb94dc7"
import script from "./crumbLayout.vue?vue&type=script&lang=js"
export * from "./crumbLayout.vue?vue&type=script&lang=js"
import style0 from "./crumbLayout.vue?vue&type=style&index=0&id=2fb94dc7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports